.recurring-repair-container{
    display: flex;
    justify-content: center;
    width: 100%;
}

.recurring-repair-content{
    display: flex;
    flex-direction: column;
    max-width: 920px;
    width: 100%;
    gap: 16px;
}

.recurring-repair-billing{
    display: flex;
    justify-content: space-between;
    gap: 32px;
}

.recurring-repair-payment{
    width: 500px;
}

.recurring-repair-summary{
    width: 350px;
}

.subscription-summary{
    padding: 16px 32px;
}

.totals-field{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.25rem;
}

.totals-field label{
    font-weight: 600;
    margin: 0;
}

.totals-field:last-child{
    margin: 0;
}

.total-price{
    font-size: 1.7rem;
}

.license-item{
    padding: 32px;
}

@media screen and (max-width: 920px){
    .recurring-repair-billing{
        flex-direction: column;
        justify-content: unset;
        gap: 16px;
    }

    .recurring-repair-payment, .recurring-repair-summary{
        width: 100%;
    }
}